"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groupForm.title': 'Add Group',
    'whatsapp.groupForm.back': 'Back',
    'whatsapp.groupForm.cancel': 'Cancel',
    'whatsapp.groupForm.save': 'Save',
    'whatsapp.groupForm.name': 'Group Name',
    'whatsapp.groupForm.namePlaceholder': 'Enter group name...',
    'whatsapp.groupForm.pinMessage': 'Pinned message',
    'whatsapp.groupForm.pinMessagePlaceholder': 'Message content to pin in the group...',
    'whatsapp.groupForm.pinMessageHint': 'When tracking is enabled and the bot is an admin, this message will be pinned.',
    'whatsapp.groupForm.nameRequired': 'Group name is required.',
    'whatsapp.groupForm.avatar': 'Avatar',
    'whatsapp.groupForm.selectAvatar': '-- Select Avatar --',
    'whatsapp.groupForm.botInstruction': 'Bot Instruction',
    'whatsapp.groupForm.botInstructionPlaceholder': 'Enter instructions for the WhatsApp bot...',
    'whatsapp.groupForm.inviteMembers': 'Invite Members',
    'whatsapp.groupForm.memberPlaceholder': 'Enter phone number or @username...',
    'whatsapp.groupForm.addMember': 'Add Member',
    'whatsapp.groupForm.noMembersYet': 'No members added yet.',
    'whatsapp.groupForm.createSuccess': 'Group created successfully.',
    'whatsapp.groupForm.createFailed': 'Failed to create group.',
};
